var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"}));
}

ArrowDown.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
